import { User } from '@vsolv/core/users/domain';
import { RecommendationSource } from './recommendation-source';

export const ADJUSTMENT_REASON_MAX_LENGTH = 1000;
export const ADJUSTMENT_SOURCE_VERSION_MAX_LENGTH = 64;

/** A charge's recommended values at one point in time. */
export interface AllowedValues {
  allowedQuantity: number | null;
  allowedRate: number | null;
  allowedAmount: number | null;
  recommendationSource: RecommendationSource | null;
}

/** One change to a charge's recommendation. Never edited: a correction is a new, higher version. */
export interface Adjustment {
  id: string;

  /** 1 for a charge's first adjustment, then +1 each time. */
  version: number;

  claimId: string;
  claimItemId: string;
  claimItemLineId: string;

  previous: AllowedValues;
  next: AllowedValues;

  reason: string;

  /** Edition of the guide or limit the values came from, when there is one. */
  sourceVersion: string | null;

  created: Date;
  createdById: string | null;
  createdBy?: User.Model | null;
}

/** Omitted values keep their current value; null clears one. */
export interface AdjustClaimItemLineRequest {
  allowedQuantity?: number | null;
  allowedRate?: number | null;
  allowedAmount?: number | null;

  recommendationSource: RecommendationSource;
  sourceVersion?: string | null;

  reason: string;

  /** Version the caller last saw, so a stale screen can't overwrite a newer recommendation. */
  expectedVersion?: number;
}

export interface AdjustClaimItemLineResponse {
  id: string;
  adjustmentVersion: number;
}

export interface ListAdjustmentsResponse {
  items: Adjustment[];
}

export function sameAllowedValues(a: AllowedValues, b: AllowedValues) {
  return (
    a.allowedQuantity === b.allowedQuantity &&
    a.allowedRate === b.allowedRate &&
    a.allowedAmount === b.allowedAmount &&
    a.recommendationSource === b.recommendationSource
  );
}
